import { openBundleById, openCategoryByName } from '~/utils/category';
import History from '~/utils/history';
import { settings } from '~/utils/settings';
import store from '~/Store';
import { POPUPS_NAME } from '~/components/PopupManager';
import { parseFiltersInQueryParams } from '~/utils/filters';
import { REDIRECT_TYPES } from '~/types/contents';
import { openUrl } from '~/utils/settings';
import { appActions } from '~/Store/appSlice';
import Account from '~/account/Account';
import { redirectToLogin } from '~/utils/utils';

export class RedirectUtils {
    static redirectTo(banner: IRedirectOptions) {
        if (banner.categoryName) {
            openCategoryByName(banner.categoryName);
            return;
        }

        switch (banner.linkType) {
            case REDIRECT_TYPES.BUNDLE:
                openBundleById(+banner.linkValue, null, { fromBanner: 'true' });
                break;

            case REDIRECT_TYPES.CATEGORY:
                openCategoryByName(banner.linkValue);
                break;

            case REDIRECT_TYPES.IFRAME:
                if (banner?.requireLogin && !Account.getAccount()) {
                    redirectToLogin();
                } else {
                    store.dispatch(
                        appActions.changeVisibilityPopup({
                            name: POPUPS_NAME.IFRAME_POPUP,
                            isVisible: true,
                            data: {
                                iframeUrl: banner.linkValue,
                            },
                        }),
                    );
                }
                break;

            case REDIRECT_TYPES.EXTERNAL:
                openUrl(banner.linkValue);
                break;

            case REDIRECT_TYPES.LINK:
            default:
                if (banner.linkValue) {
                    History.navigate(`/${settings.languageCode}${banner.linkValue}`);
                    parseFiltersInQueryParams();
                }
                break;
        }
    }
}
